module.exports = __webpack_public_path__ + "img/inco3Ac.96ed33f4.png";